import {Modal} from 'react-bootstrap'
import styles from './FTUEModal.css'

const IOS_VERSION_MINIMAL = 'v13.0'
const ANDROID_VERSION_MINIMAL = 'v8.0'

const FTUEModal = ({show, onConfirm}) => {
  return <Modal show={show} dialogClassName={styles['dialog']} onHide={() => { return false }}>
    <Modal.Body bsClass={`${styles.body} modal-body`}>
      <div className='row'>
        <div className={`col-xs-12 ${styles.video}`}>
          <iframe width='270' height='190' src='https://www.youtube.com/embed/QqGY1ohpKMQ' frameBorder={0} allowFullScreen id='video' />
        </div>
      </div>
      <div className='row'>
        <div className={`col-xs-12 ${styles.new}`}>
          new
        </div>
      </div>
      <div className='row'>
        <div className={`col-xs-12 ${styles.title}`}>
          Moka Employee Management
        </div>
      </div>
      <div className='row'>
        <div className={`col-xs-12 ${styles.description}`}>
          <p>Doesn't matter if your business have one or many employees. Moka Employee Management help you manage your staff and let them do what they do best</p>
          <p>Please make sure you have updated your Moka App to the latest version to use Moka Employee Management</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <button className='btn btn-primary btn-block' onClick={onConfirm}>
            Got it!
          </button>
        </div>
      </div>
      <div className='row'>
        <div className={`col-xs-12 ${styles.compat}`}>
          <b>Compatibility</b>: Requires Moka App {ANDROID_VERSION_MINIMAL} (android) or {IOS_VERSION_MINIMAL} (iOS) or newer.
        </div>
      </div>
    </Modal.Body>

  </Modal>
}

export default FTUEModal



// WEBPACK FOOTER //
// ./app/pages/Employees/FTUEModal/FTUEModal.js